export const avatarSrc = (url) => (url && url.startsWith('/api/') ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url || undefined);

// Reduz a foto para 512px (quadrada, centrada) antes de enviar
export const squareResize = (file, size = 512) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => {
    const s = Math.min(img.width, img.height);
    const c = document.createElement('canvas');
    c.width = size; c.height = size;
    c.getContext('2d').drawImage(img, (img.width - s) / 2, (img.height - s) / 2, s, s, 0, 0, size, size);
    c.toBlob((b) => (b ? resolve(new File([b], 'foto.jpg', { type: 'image/jpeg' })) : reject(new Error('resize'))), 'image/jpeg', 0.88);
    URL.revokeObjectURL(img.src);
  };
  img.onerror = reject;
  img.src = URL.createObjectURL(file);
});
